import React, {useContext, useEffect, useState, useCallback} from 'react';
import AccountsModal from '../../components/modals/AccountsModal';
import DeleteModal from '../../components/modals/DeleteModal';
import SuccessNotification from '../../components/toast/SuccessNotification';
import ErrorNotification from '../../components/toast/ErrorNotification';
import {AccountsContext} from '../../context/AccountsProvider';
import {FaTrashAlt, FaUserSecret} from 'react-icons/fa';

export default function VendorAccounts({vendorId}) {
  const {
    accounts, getAccounts, handleImpersonate, deleteAccount,
  } = useContext(AccountsContext);
  const [showAccountsModal, setShowAccountsModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const isFetched = React.useRef(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [successText, setSuccessText] = useState('');
  const [errorText, setErrorText] = useState('');
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [accountToDelete, setAccountToDelete] = useState(null);

  const fetchAccounts = useCallback(() => {
    if (!isFetched.current) {
      getAccounts(vendorId)
        .catch((error) => {
          console.error('Error fetching accounts:', error);
          setShowError(true);
          setErrorText('Error fetching accounts');
        })
        .finally(() => {
          isFetched.current = true;
        });
    }
  }, [vendorId, getAccounts]);

  useEffect(() => {
    fetchAccounts();
  }, [fetchAccounts]);

  const handleAddAccountClick = () => {
    setSelectedAccount({
      username: '', email: '', role: '', portalActivated: false,
    });
    setShowAccountsModal(true);
  };

  const handleDeleteClick = (accountId) => {
    setAccountToDelete(accountId);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirmation = async (accountId) => {
    setShowDeleteModal(false);
    try {
      await deleteAccount(accountId);
      isFetched.current = false;
      fetchAccounts();
      setShowSuccess(true);
      setSuccessText('Account deleted successfully.');
    } catch (error) {
      setShowError(true);
      setErrorText('Failed to delete account.');
      console.error('Failed to delete account:', error);
    }
  };

  const closeNotification = () => {
    setShowSuccess(false);
    setShowError(false);
  };

  return (<div className="modal mb-6 flex h-full flex-col">
      <div className="modal-content flex-grow p-4">
        {accounts.length === 0 ? (<div
            className="mb-6 mt-6 flex w-1/3 flex-col items-center justify-center space-y-4 rounded-md bg-gray-100 py-32 text-center text-gray-500 dark:bg-stone-800 dark:text-gray-200 sm:w-1/3 md:w-1/2 lg:mx-auto lg:w-3/4">
            <p>No Accounts Found.</p>
            <button onClick={handleAddAccountClick} className="primary-large">
              Add Account
            </button>
          </div>) : (<>
            <div className="mb-4 flex justify-start">
              <button onClick={handleAddAccountClick} className="primary-large">
                Add Account
              </button>
            </div>
            <div
              className="h-[650px] overflow-y-auto"
            >
              <table className="w-full text-gray-600 dark:text-gray-300">
                <thead className="vendor-table-header">
                <tr className="text-left">
                  <th className="vendor-table-label">Username</th>
                  <th className="vendor-table-label">Email</th>
                  <th className="vendor-table-label">Actions</th>
                </tr>
                </thead>
                <tbody>
                {accounts.map((account) => (<tr key={account.id} className="vendor-table-row">
                    <td className="px-2 py-2">{account.username}</td>
                    <td className="px-2 py-2">{account.email}</td>
                    <td className="flex items-center px-2 py-2">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImpersonate(account.id);
                        }}
                        className="inline-flex items-center px-2 py-1 text-sm text-blue-500 dark:text-indigo-500 hover:text-white dark:hover:text-white rounded border border-blue-500 dark:border-indigo-500 hover:bg-blue-500 dark:hover:bg-indigo-500 focus:outline-none focus:shadow-outline"
                        title="Impersonate User"
                      >
                        <FaUserSecret className="h-5 w-5"/>
                        <span className="ml-2">Impersonate</span>
                      </button>

                      {/*<button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImpersonate(account.id);
                        }}
                        className="inline-flex items-center px-2 py-1 text-sm text-blue-500 dark:text-indigo-500 hover:text-white dark:hover:text-white rounded border border-blue-500 dark:border-indigo-500 hover:bg-blue-500 dark:hover:bg-indigo-500 focus:outline-none focus:shadow-outline"
                        title="Impersonate User"
                      >
                        <LiaHotdogSolid  className="h-5 w-5"/>
                        <span className="ml-2">Titillate</span>
                      </button>*/}

                      {/*<button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImpersonate(account.id);
                        }}
                        className="inline-flex items-center px-2 py-1 text-sm text-blue-500 dark:text-indigo-500 hover:text-white dark:hover:text-white rounded border border-blue-500 dark:border-indigo-500 hover:bg-blue-500 dark:hover:bg-indigo-500 focus:outline-none focus:shadow-outline"
                        title="Impersonate User"
                      >
                        <FaCross className="h-5 w-5"/>
                        <span className="ml-2">Excommunicate</span>
                      </button>*/}

                      {/*<button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImpersonate(account.id);
                        }}
                        className="inline-flex items-center px-2 py-1 text-sm text-blue-500 dark:text-indigo-500 hover:text-white dark:hover:text-white rounded border border-blue-500 dark:border-indigo-500 hover:bg-blue-500 dark:hover:bg-indigo-500 focus:outline-none focus:shadow-outline"
                        title="Impersonate User"
                      >
                        <TbMathXDivideY2/>
                        <span className="ml-2">Interpolate</span>
                      </button>*/}

                      {/*<button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImpersonate(account.id);
                        }}
                        className="inline-flex items-center px-2 py-1 text-sm text-blue-500 dark:text-indigo-500 hover:text-white dark:hover:text-white rounded border border-blue-500 dark:border-indigo-500 hover:bg-blue-500 dark:hover:bg-indigo-500 focus:outline-none focus:shadow-outline"
                        title="Impersonate User"
                      >
                        ∫
                        <span className="ml-2">Integrate</span>
                      </button>*/}

                      {/*<button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImpersonate(account.id);
                        }}
                        className="inline-flex items-center px-2 py-1 text-sm text-blue-500 dark:text-indigo-500 hover:text-white dark:hover:text-white rounded border border-blue-500 dark:border-indigo-500 hover:bg-blue-500 dark:hover:bg-indigo-500 focus:outline-none focus:shadow-outline"
                        title="Impersonate User"
                      >
                        <LuPartyPopper className="h-5 w-5"/>
                        <span className="ml-2">Congratulate</span>
                      </button>*/}

                      {/*<button*/}
                      {/*  onClick={(e) => {*/}
                      {/*    e.stopPropagation();*/}
                      {/*    handleImpersonate(account.id);*/}
                      {/*  }}*/}
                      {/*  className="focus:shadow-outline inline-flex items-center rounded border border-blue-500 px-2 py-1 text-sm text-blue-500 hover:bg-blue-500 hover:text-white focus:outline-none dark:border-indigo-500 dark:text-indigo-500 dark:hover:bg-indigo-500 dark:hover:text-white"*/}
                      {/*  title="Impersonate User"*/}
                      {/*>*/}
                      {/*  <GiBackPain className="h-5 w-5" />*/}
                      {/*  <span className="ml-2">Excoriate</span>*/}
                      {/*</button>*/}

                      {/*<button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImpersonate(account.id);
                        }}
                        className="inline-flex items-center px-2 py-1 text-sm text-blue-500 dark:text-indigo-500 hover:text-white dark:hover:text-white rounded border border-blue-500 dark:border-indigo-500 hover:bg-blue-500 dark:hover:bg-indigo-500 focus:outline-none focus:shadow-outline"
                        title="Impersonate User"
                      >
                        <MdCalculate className="h-5 w-5"/>
                        <span className="ml-2">Calculate</span>
                      </button>*/}

                      {/*<button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImpersonate(account.id);
                        }}
                        className="inline-flex items-center px-2 py-1 text-sm text-blue-500 dark:text-indigo-500 hover:text-white dark:hover:text-white rounded border border-blue-500 dark:border-indigo-500 hover:bg-blue-500 dark:hover:bg-indigo-500 focus:outline-none focus:shadow-outline"
                        title="Impersonate User"
                      >
                        <GiReceiveMoney className="h-5 w-5"/>
                        <span className="ml-2">Accumulate </span>
                      </button>*/}

                      {/*<button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImpersonate(account.id);
                        }}
                        className="inline-flex items-center px-2 py-1 text-sm text-blue-500 dark:text-indigo-500 hover:text-white dark:hover:text-white rounded border border-blue-500 dark:border-indigo-500 hover:bg-blue-500 dark:hover:bg-indigo-500 focus:outline-none focus:shadow-outline"
                        title="Impersonate User"
                      >
                        <GiStairs className="h-5 w-5"/>
                        <span className="ml-2">Escalate</span>
                      </button>*/}

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick(account.id);
                        }}
                        className="focus:shadow-outline ml-2 inline-flex items-center rounded border border-red-500 px-2 py-1 text-sm text-red-500 hover:bg-red-500 hover:text-white focus:outline-none"
                        title="Delete Account"
                      >
                        <FaTrashAlt className="h-5 w-5"/>
                        <span className="ml-2">Delete</span>
                      </button>
                    </td>
                  </tr>))}
                </tbody>
              </table>
            </div>
          </>)}
      </div>

      {showAccountsModal && (<AccountsModal
          vendorId={vendorId}
          isOpen={showAccountsModal}
          onClose={() => setShowAccountsModal(false)}
          account={selectedAccount}
          onSuccess={(message) => {
            setSuccessText(message);
            setShowSuccess(true);
            isFetched.current = false;
            fetchAccounts();
          }}
          onError={(message) => {
            setErrorText(message);
            setShowError(true);
          }}
        />)}

      {showDeleteModal && (<DeleteModal
          title="Are you sure?"
          onCancel={() => setShowDeleteModal(false)}
          onDelete={() => handleDeleteConfirmation(accountToDelete)}
        />)}

      {showSuccess && (<SuccessNotification
          show={showSuccess}
          onClose={closeNotification}
          text={successText}
        />)}
      {showError && (<ErrorNotification
          show={showError}
          onClose={closeNotification}
          text={errorText}
        />)}
    </div>);
}
